import PropTypes from 'prop-types';
import React from 'react';

import { EventItem } from '$partials/listings';
import { IconArrowRight } from '$partials/icons/index.js';
import { formatUrlWithActiveFund } from '$utilities/format';
import { DetailDialogProvider } from '$pages/detail/detail-page-provider';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const EventListing = ({
    eventListing,
    items,
    sidebarTitle,
}) => {

    return (
        <div className='layout-container-padding-right flex flex-col flex-wrap max-w-container bg-white mt-40 rounded-md'>

            <div className='flex sm:pr-40 py-75 sm:py-60 md:py-100'>
                <div className='w-sidebar sm:pt-10'>
                    <div className='flex flex-col items-center'>
                        <h2 className='type-style-8 align-middle rotate-180 writing-mode-vertical-rl max-sm:inline-block'>
                            {sidebarTitle}
                        </h2>
                    </div>
                </div>
                <section
                    aria-label='Events'
                    className='sm:pt-10 flex-1 flex flex-wrap self-start'
                    role='feed'>
                    <DetailDialogProvider>
                        {items?.length > 0 ? (
                            <>
                                {/* mobile & desktop */}
                                <div className='grid sm:hidden md:grid w-full grid-cols-1 md:grid-cols-1 gap-y-60 md:gap-y-80'>
                                    {items?.slice(0, 3).map((item) => {
                                        let now = new Date();
                                        let eventdate = new Date(item.eventDate);
                                        return (
                                            <EventItem
                                                key={item.id}
                                                openToModal={true}
                                                type={eventdate.getTime() > now.getTime()  ? 'Upcoming' : 'Past'}
                                                {...item} />
                                        );
                                    })}
                                </div>
                                {/* tablet */}
                                <div className='hidden sm:grid md:hidden w-full sm:grid-cols-2 sm:gap-x-70 gap-y-10 sm:gap-y-40'>
                                    {items?.slice(0, 2).map((item) => {
                                        let now = new Date();
                                        let eventdate = new Date(item.eventDate);
                                        return (
                                            <EventItem
                                                key={item.id}
                                                openToModal={true}
                                                type={eventdate.getTime() > now.getTime() ? 'Upcoming' : 'Past'}
                                                {...item} />
                                        );
                                    })}
                                </div>

                                {eventListing.url && (
                                    <div className='arrow-button mt-55'>
                                        <a
                                            className='bg-grey px-12 py-5 sm:py-8 rounded-3xl h-fit'
                                            href={formatUrlWithActiveFund(eventListing.url)}>
                                            <span className='inline-flex items-center gap-5'>
                                                All events
                                                <IconArrowRight />
                                            </span>
                                        </a>
                                    </div>
                                )}
                            </>
                        ) : (
                            <>
                            There are currently no upcoming events. Please check again later.
                            </>
                        )}
                    </DetailDialogProvider>
                </section>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    eventListing: PropTypes.object,
    items: PropTypes.array,
    sidebarTitle: PropTypes.string,
};


EventListing.propTypes = propTypes;

export default EventListing;
